var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H5C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H11C11.5523 17 12 16.5523 12 16C12 15.4477 11.5523 15 11 15H5V5H11C11.5523 5 12 4.55228 12 4C12 3.44772 11.5523 3 11 3Z",
    fill: "url(#paint0_linear_logout)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5858 8.99992L12.2929 6.70703C11.9024 6.3165 11.9024 5.68334 12.2929 5.29281C12.6834 4.90229 13.3166 4.90229 13.7071 5.29281L17.7071 9.29281C18.0976 9.68334 18.0976 10.3165 17.7071 10.707L13.7071 14.707C13.3166 15.0975 12.6834 15.0975 12.2929 14.707C11.9024 14.3165 11.9024 13.6833 12.2929 13.2928L14.5858 10.9999H8C7.44772 10.9999 7 10.5522 7 9.99992C7 9.44764 7.44772 8.99992 8 8.99992H14.5858Z",
    fill: "url(#paint0_linear_logout)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_logout",
    x1: 9.74975,
    y1: 0,
    x2: 9.74975,
    y2: 19.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7542E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#4F75D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620192,
    stopColor: "#4FAABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE382"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b813e4dc9359ff81db8a1f89774dafed.svg";
export { ForwardRef as ReactComponent };